import {ICompositeNode} from "@feature/nodes/models/node-type";
import {Field} from "@feature/_app_modules/related-contacts/models/related-contacts-types";
import {RelatedContactFieldComponent} from "@feature/_app_modules/related-contacts/components/related-contact-field/related-contact-field.component";
import { RendererFunction } from '../types/renderer-function';

export const fieldRendererFunc : RendererFunction = (viewContainerRef, node) => {
  const component = viewContainerRef.createComponent(RelatedContactFieldComponent);
  const currentnode = node as ICompositeNode<Field>
  component.instance.children = currentnode.Children;
  component.instance.field = currentnode.Props
}
